import {
    IfgGatewayIntegrationFile,
    IfgGatewayIntegrationFileFileData,
    OrderQueueOption,
    OrderQueueOptions
} from '@trade-platform/ui-shared';
import { JsonDecoder } from 'ts.data.json';

export const orderQueueOptionsDecoder = JsonDecoder.object<OrderQueueOptions>(
    {
        // Nullable rather than optional: an order with no pending approval has no current queue, and
        // the server says so explicitly rather than omitting the key.
        currentConfigId: JsonDecoder.nullable(JsonDecoder.number),
        currentLabel: JsonDecoder.nullable(JsonDecoder.string),
        options: JsonDecoder.array(
            JsonDecoder.object<OrderQueueOption>(
                {
                    configId: JsonDecoder.number,
                    label: JsonDecoder.string,
                    value: JsonDecoder.string,
                    isCurrent: JsonDecoder.boolean
                },
                'OrderQueueOption'
            ),
            'OrderQueueOption[]'
        )
    },
    'OrderQueueOptions'
);

export const ifgGatewayIntegrationFileDecoder = JsonDecoder.array(
    JsonDecoder.object<IfgGatewayIntegrationFile>(
        {
            id: JsonDecoder.number,
            displayName: JsonDecoder.string,
            isSuccess: JsonDecoder.optional(JsonDecoder.boolean),
            message: JsonDecoder.optional(JsonDecoder.string),
            lastSent: JsonDecoder.optional(JsonDecoder.string),
            type: JsonDecoder.optional(JsonDecoder.string),
            fileData: JsonDecoder.optional(
                JsonDecoder.object<IfgGatewayIntegrationFileFileData>(
                    {
                        url: JsonDecoder.string,
                        version: JsonDecoder.string,
                        bucket: JsonDecoder.string,
                        MB: JsonDecoder.string,
                        fileId: JsonDecoder.optional(JsonDecoder.string),
                        userId: JsonDecoder.optional(JsonDecoder.string),
                        ticketId: JsonDecoder.optional(JsonDecoder.string)
                    },
                    'IfgIntegrationFileFileData'
                )
            )
        },
        'IfgGatewayIntegrationFile'
    ),
    'IfgGatewayIntegrationFile[]'
);
